export default function TableRow({ children }) {
  return (
    <tr className="border-b">
      {children}
    </tr>
  );
}
